export const bronzSponsorlar = [
  {
    id: 1,
    name: "Aly",
    imageUrl: "/assets/sponsorlar/bronz/aly.png",
    url: "#"
  },
  {
    id: 2,
    name: "Atakum Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/atakum.png",
    url: "https://atakum.bel.tr/"
  },
  {
    id: 1,
    name: "Armor",
    imageUrl: "/assets/sponsorlar/bronz/armor.png",
    url: "#https://armor.com.tr/"
  },
  {
    id: 3,
    name: "Bafra Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/bafra.png",
    url: "https://www.bafra.bel.tr/"
  },
  {
    id: 3,
    name: "Bilgi Eğitim Kurumları",
    imageUrl: "/assets/sponsorlar/bronz/bilgi.png",
    url: "https://www.samsunbilgiokullari.com/"
  },
  {
    id: 4,
    name: "Canik Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/canik-belediyesi.png",
    url: "https://www.canik.bel.tr/"
  },
  {
    id: 5,
    name: "Çarşamba Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/carsamba.png",
    url: "https://www.carsamba.bel.tr/"
  },
  {
    id: 4,
    name: "Çiba Cam",
    imageUrl: "/assets/sponsorlar/bronz/ciba.png",
    url: "http://www.cibacam.com.tr/"
  },
  {
    id: 6,
    name: "DeltaV Uzay Teknolojileri",
    imageUrl: "/assets/sponsorlar/bronz/delta-v.png",
    url: "https://deltav.com.tr/"
  },
  {
    id: 7,
    name: "Dünya Mühendislik",
    imageUrl: "/assets/sponsorlar/bronz/dunya-muhendislik.png",
    url: "http://dunyamuh.com/"
  },
  {
    id: 8,
    name: "Erçal Fındık Otomotiv San. Ve Tic. A.Ş.",
    imageUrl: "/assets/sponsorlar/bronz/ercal.png",
    url: "https://www.ercal.com.tr/"
  },
  {
    id: 9,
    name: "Final Okulları",
    imageUrl: "/assets/sponsorlar/bronz/final.png",
    url: "https://samsun.finalokullari.com.tr/"
  },
  {
    id: 10,
    name: "FBM Estetik Tıp Merkezi",
    imageUrl: "/assets/sponsorlar/bronz/fbm-estetik.png",
    url: "https://www.fbm.com.tr/"
  },
  {
    id: 10,
    name: "Hampton By Hilton",
    imageUrl: "/assets/sponsorlar/bronz/hampton.png",
    url: "#"
  },
  {
    id: 12,
    name: "Havelsan",
    imageUrl: "/assets/sponsorlar/bronz/havelsan.png",
    url: "https://www.havelsan.com.tr/"
  },
  {
    id: 11,
    name: "Havza Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/havza.png",
    url: "https://www.havza.bel.tr/"
  },
  {
    id: 13,
    name: "İlkadım Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/ilkadim.png",
    url: "https://www.ilkadim.bel.tr/"
  },
  {
    id: 13,
    name: "Keneviro",
    imageUrl: "/assets/sponsorlar/bronz/kenevir.png",
    url: "https://keneviro.com.tr/tr"
  },
  {
    id: 13,
    name: "Lunart",
    imageUrl: "/assets/sponsorlar/bronz/lunart.png",
    url: "#"
  },
  {
    id: 14,
    name: "Mah-Ya",
    imageUrl: "/assets/sponsorlar/bronz/mahya.png",
    url: "https://www.mahya.com.tr/"
  },
  {
    id: 1,
    name: "19 Mayıs Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/19mayis.png",
    url: "https://www.19mayis.bel.tr/"
  },
  {
    id: 15,
    name: "Özel Göktürk Havacılık Lisesi",
    imageUrl: "/assets/sponsorlar/bronz/gokturk.png",
    url: "https://gokturkhavaciliklisesi.com/"
  },
  {
    id: 15,
    name: "Pera Özel Eğitim Kurumları",
    imageUrl: "/assets/sponsorlar/bronz/pera.png",
    url: "http://www.pe-ra.com/"
  },
  {
    id: 16,
    name: "Samsun Segman",
    imageUrl: "/assets/sponsorlar/bronz/segman.png",
    url: "https://samsunsegman.com/"
  },
  {
    id: 17,
    name: "Taç Makina",
    imageUrl: "/assets/sponsorlar/bronz/tac-makina.png",
    url: "https://www.tacmak.com/"
  },
  {
    id: 19,
    name: "Tekkeköy Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/tekkekoy.png",
    url: "https://tekkekoy.bel.tr/"
  },
  {
    id: 17,
    name: "Tellioğlu Metal",
    imageUrl: "/assets/sponsorlar/bronz/tellioglu.png",
    url: "https://www.tellioglumetal.com.tr/"
  },
  {
    id: 18,
    name: "Terme Belediyesi",
    imageUrl: "/assets/sponsorlar/bronz/terme.png",
    url: "https://www.terme.bel.tr/"
  },
  {
    id: 20,
    name: "Topaloğlu Balıkçılık",
    imageUrl: "/assets/sponsorlar/bronz/balikci.png",
    url: "#"
  },
  {
    id: 21, 
    name: "Türkşeker",
    imageUrl: "/assets/sponsorlar/bronz/turk-seker.png",
    url: "https://www.turkseker.gov.tr/"
  },
  {
    id: 22,
    name: "Türk Telekom",
    imageUrl: "/assets/sponsorlar/bronz/turk-telekom.png",
    url: "https://www.turktelekom.com.tr/"
  },
  {
    id: 23,
    name: "Vezirköprü Orman Ürünleri ve Kağıt",
    imageUrl: "/assets/sponsorlar/bronz/peli.png",
    url: "https://www.peliparke.com/"
  },
  {
    id: 23,
    name: "Yağmaksan",
    imageUrl: "/assets/sponsorlar/bronz/yagmaksan.png",
    url: "https://www.yagmaksan.com/"
  },
  {
    id: 24,
    name: "Yaşar Makina",
    imageUrl: "/assets/sponsorlar/ana/yasarGrup.png",
    url: "https://www.yasargroup.com.tr/"
  },
  {
    id: 25,
    name: "Yenibiriş",
    imageUrl: "/assets/sponsorlar/bronz/yenibiris.png",
    url: "#https://www.yenibiris.com/"
  },
  {
    id: 25,
    name: "Yön A.Ş.",
    imageUrl: "/assets/sponsorlar/bronz/yon.png",
    url: "#"
  }
]